import Vue from 'vue'
import numeral from 'numeral'
// import numFormat from 'vue-filter-number-format'
import moment from 'moment'
import localeFormat from '../constants/dateFormat'
import store from '../store'

Vue.filter('numFormat', function (num) {
  if (num === '-') { return '-' }
  if (num === '') { return '' }
  return numeral(num).format('0,0')
})
Vue.filter('marketing', function (campaign) {
  return campaign.isTransactional === false
})
Vue.filter('transactional', function (campaign) {
  return campaign.isTransactional === true
})
Vue.filter('cleanURL', function (url) {
  url = String(url)
  if (url.indexOf(' ') >= 0) {
    return url.substring(url.lastIndexOf(' ') + 1)
  } else {
    return url
  }
})
Vue.filter('dateOnlyFormat', function (date) {
  const locale = store.getters.getLocale
  const formatDate = localeFormat.dateFormat(locale)
  return moment(String(date)).format(formatDate)
})
Vue.filter('dateFormat', function (date) {
  const locale = store.getters.getLocale
  const formatDate = localeFormat.dateFormat(locale)
  const formatTime = localeFormat.timeFormat(locale)
  return moment(String(date)).format(formatDate + ' ' + formatTime)
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})
Vue.filter('humanize', function (value) {
  if (!value) return ''
  const words = value.split('_')
  return words.map((word) => {
    return word[0].toUpperCase() + word.substring(1)
  }).join(' ')
})

// Vue.filter('numFormat', function (value, format = '0,0') {
//   return numeral(value).format(format)
// })
